import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import * as XLSX from 'xlsx';
import { WorkSheet } from 'xlsx';
import { Roles } from '../../core/ucr-security/roles';
import { UcrSecurityService } from '../../core/ucr-security/ucr-security.service';
import { UserInfo } from '../../core/ucr-security/user-info';
import { AlertService } from '../../shared/services/alert.service';
import { EmailService } from '../email.service';
import { EmailMessage } from '../email.type';

@Component({
    selector: 'app-email-card-view',
    templateUrl: './email-card-view.component.html',
    styleUrls: ['./email-card-view.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class EmailCardViewComponent implements OnInit {
    @Input() alias: string;
    @Input() id: number | bigint;
    @Input() domainClass: string;
    emails: Array<EmailMessage>;
    private userInfo: UserInfo;
    loading: boolean;
    mayResend: boolean = false;
    maySeeBcc: boolean = false;

    constructor(private email: EmailService, private alert: AlertService, private security: UcrSecurityService) {
        this.security.getUserInfo().subscribe((userInfo) => {
            this.userInfo = userInfo;
            this.mayResend = false;
            this.maySeeBcc = userInfo?.ifAnyGranted([Roles.siteAdmin]);
        });
    }

    ngOnInit(): void {
        this.loading = true;
        this.email
            .index({
                id: this.id,
                alias: this.alias
            })
            .subscribe(
                (emails) => {
                    this.emails = emails;
                    this.loading = false;
                },
                (error) => {
                    this.alert.toastErrorObject(error);
                    this.loading = false;
                }
            );
    }

    get mayExport(): boolean {
        return this.userInfo?.ifAnyGranted([Roles.siteAdmin]);
    }

    export() {
        if (this.mayExport) {
            const jsonData = [];
            this.emails.forEach((m) => {
                const email = {
                    'Date Sent': m.sentDate,
                    To: m.to?.join(' '),
                    CC: m.cc?.join(' '),
                    Subject: m.subject,
                    Body: ''
                };
                const b = document.createElement('div');
                b.innerHTML = m.text;
                const styleTags = b.querySelectorAll('style');
                if (styleTags) {
                    styleTags.forEach((styleTag) => {
                        styleTag.remove();
                    });
                }
                email['Body'] = this.htmlToText(b.innerHTML);
                jsonData.push(email);
            });
            const ws: WorkSheet = XLSX.utils.json_to_sheet(jsonData);
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Processing Queue');
            const fName = 'emails' + new Date().toISOString().split('T')[0] + '.xlsx';
            XLSX.writeFile(wb, fName);
            this.alert.toastSuccess('File downloaded.');
        } else {
            this.alert.toastWarn('Looks like you may not have access to this!');
        }
    }

    htmlToText(html) {
        //remove code brakes and tabs
        html = html.replace(/\n/g, '');
        html = html.replace(/\t/g, '');

        //keep html brakes and tabs
        html = html.replace(/<\/td>/g, '\t');
        html = html.replace(/<\/table>/g, '\n');
        html = html.replace(/<\/tr>/g, '\n');
        html = html.replace(/<\/p>/g, '\n');
        html = html.replace(/<\/div>/g, '\n');
        html = html.replace(/<\/h>/g, '\n');
        html = html.replace(/<br>/g, '\n');
        html = html.replace(/<br( )*\/>/g, '\n');

        //parse html into text
        const dom = new DOMParser().parseFromString('<!doctype html><body>' + html, 'text/html');
        return dom.body.textContent;
    }

    emailResent($event: EmailMessage) {
        if ($event) {
            this.emails.unshift($event);
        }
    }
}
